import { registerAction } from '../../Action'
import { PhaseItemsActions } from './PhaseItemsActions'

const updateNestedState = (state, view, updates) => ({
  ...state,
  entityDataByView: {
    ...(state.entityDataByView && state.entityDataByView),
    [view]: {
      ...(state.entityDataByView && state.entityDataByView[view]),
      ...updates,
    },
  },
})

const fetchPhaseItemsRequestReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    fetching: true,
  })

const fetchPhaseItemsSuccessReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    fetching: false,
  })

const fetchPhaseItemsErrorReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    phaseItemsError: action.payload.error,
    fetching: false,
  })

export const fetchPhaseItemsRequest = registerAction(
  PhaseItemsActions.FETCH_ALL_PHASE_ITEMS_REQUEST,
  { reducer: fetchPhaseItemsRequestReducer }
)
export const fetchPhaseItemsSuccess = registerAction(
  PhaseItemsActions.FETCH_ALL_PHASE_ITEMS_SUCCESS,
  { reducer: fetchPhaseItemsSuccessReducer }
)
export const fetchPhaseItemsError = registerAction(
  PhaseItemsActions.FETCH_ALL_PHASE_ITEMS_ERROR,
  { reducer: fetchPhaseItemsErrorReducer }
)

export default {
  fetchPhaseItemsError,
  fetchPhaseItemsRequest,
  fetchPhaseItemsSuccess,
}
